import { SvgSprite } from "./SvgSprite";

import { Link } from "react-router-dom";

export const BrowserUpgradeNotification = (): JSX.Element => {
  return (
    <section
      role="alert"
      className="p-4 bg-secondary text-light"
      css={`
        position: fixed;
        bottom: 0;
        right: 0;
        width: 100%;

        @media (min-width: ${(p) => p.theme.mdBreakpoint}) {
          bottom: 3rem;
          right: 3rem;
          width: 500px;
        }

        @supports (display: none) {
          display: none;
          visibility: hidden;
        }
      `}
    >
      <SvgSprite
        id="personas:one"
        width={48}
        height={48}
        css={`
          position: absolute;
          top: 0;
          right: 1rem;
          margin-top: -43px;
        `}
      />

      <h4>Browser upgrade recommended</h4>
      <p>
        It looks like you may be using a web browser version that we don&apos;t
        support. Make sure you&apos;re using the most recent version of your
        browser, or try using Microsoft Edge or Google Chrome, to get the full
        SEEK Volunteer experience.
      </p>
      <Link className="btn btn-outline-light" to="/browser-upgrade">
        Learn more
        <SvgSprite width={16} height={16} id="icons:chev-right" />
      </Link>
    </section>
  );
};

export const BrowserUpgradeNotificationNsw = (): JSX.Element => {
  return (
    <section
      role="alert"
      className="p-4 bg-primary text-light"
      css={`
        position: fixed;
        bottom: 0;
        right: 0;
        width: 100%;

        @media (min-width: ${(p) => p.theme.mdBreakpoint}) {
          bottom: 3rem;
          right: 3rem;
          width: 500px;
        }

        @supports (display: none) {
          display: none;
          visibility: hidden;
        }
      `}
    >
      <h1 className="text-light">Browser upgrade recommended</h1>
      <p>
        It looks like you may be using a web browser version that we don&apos;t
        support. Make sure you&apos;re using the most recent version of your
        browser, or try using Microsoft Edge or Google Chrome, to get the full
        experience.
      </p>
      <Link className="btn btn-outline-light" to="/browser-upgrade">
        Learn more
        <SvgSprite width={16} height={16} id="icons:chev-right" />
      </Link>
    </section>
  );
};
